export default "__VITE_ASSET__776c86d2__"